import { useState } from 'react';
import {
  IonContent,
  IonLabel,
  IonPage,
  IonSegment,
  IonSegmentButton,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { AppSectionHeader } from '../../components/ui/AppSectionHeader';
import { ProfilesNetworkContent } from './components/ProfilesNetworkContent';
import { OrganizationsNetworkContent } from './components/OrganizationsNetworkContent';

type NetworkSegment = 'perfiles' | 'entidades';

// "Red" tab: search of people (profiles) and of the organizations of their
// football careers (clubs, federations, media...).
export const NetworkTab = () => {
  const [segment, setSegment] = useState<NetworkSegment>('perfiles');

  return (
    <IonPage>
      <AppSectionHeader variant="main">
        <IonToolbar>
          <IonTitle className="ml-4">Red</IonTitle>
        </IonToolbar>
      </AppSectionHeader>
      <IonContent className="ion-padding">
        <IonSegment
          value={segment}
          onIonChange={(event) => setSegment(event.detail.value as NetworkSegment)}
          className="mb-4"
        >
          <IonSegmentButton value="perfiles">
            <IonLabel>Perfiles</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="entidades">
            <IonLabel>Entidades</IonLabel>
          </IonSegmentButton>
        </IonSegment>

        {segment === 'perfiles' ? <ProfilesNetworkContent /> : <OrganizationsNetworkContent />}
      </IonContent>
    </IonPage>
  );
};
